module.exports = __webpack_public_path__ + "img/icon-verify.a3a9a7ca.svg";